import PageLayoutDesktop from 'src/components/account/PageLayout/PageLayoutDesktop';
import PasswordResetContent from 'src/components/account/PasswordResetPage/components/PasswordResetContent';

const ResetDesktopPage = () => (
  <PageLayoutDesktop>
    <PasswordResetContent />
  </PageLayoutDesktop>
);

export default ResetDesktopPage;
